module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown notifications-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-warning"
  }, [_vm._v(_vm._s(_vm._f("count")(_vm.filterBy(_vm.filterBy(_vm.registros, true, 'is_alarme'), 1, 'valor'))))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "row no-margin"
  }, _vm._l((_vm.filterBy(_vm.filterBy(_vm.registros, true, 'is_alarme'), 1, 'valor')), function(registro) {
    return _c('span', {
      staticClass: "col-xs-12 col-md-6 tab-link"
    }, [(_vm.flag === 'br') ? _c('i', {
      staticClass: "fa fa-warning"
    }, [_vm._v(" " + _vm._s(registro.labelPtBr))]) : (_vm.flag === 'de') ? _c('i', {
      staticClass: "fa fa-warning"
    }, [_vm._v(" " + _vm._s(registro.labelDe))]) : (_vm.flag === 'us') ? _c('i', {
      staticClass: "fa fa-warning"
    }, [_vm._v(" " + _vm._s(registro.labelEn))]) : _c('i', {
      staticClass: "fa fa-warning"
    }, [_vm._v(" " + _vm._s(registro.labelEs))])])
  }))]), _vm._v(" "), _c('li', [(_vm.tab === 'old') ? _c('ul', {
    staticClass: "menu"
  }, [_vm._l((_vm.filterBy(_vm.filterBy(_vm.registros, true, 'is_alarme'), 1, 'valor')), function(notification) {
    return _c('notification-item', {
      key: notification.id,
      attrs: {
        "notification": notification
      }
    })
  }), _vm._v(" "), (!_vm.oldNotifications.length) ? _c('li', [_c('span', {
    staticClass: "center-block text-center"
  }, [_vm._v("Não existe nenhum alerta/alarme")])]) : _vm._e()], 2) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a0f9940"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/NotificationsMenu.vue
// module id = 413
// module chunks = 1